<template>
  <div>
    <v-card>
      <v-toolbar>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title
          >Добавить пользователя: {{ user.name }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn @click="save" :disabled="progress">
          <v-icon left>save</v-icon>Записать
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            :rules="rules.emailRules"
            prepend-icon="email"
            type="email"
            required
            label="Логин (изменить потом нельзя)"
            v-model="user.email"
          ></v-text-field>

          <v-text-field
            :rules="rules.nameRules"
            required
            label="*Фамилия"
            v-model="user.famil"
          ></v-text-field>

          <v-text-field
            :rules="rules.nameRules"
            required
            label="*Имя"
            v-model="user.name"
          ></v-text-field>

          <v-text-field label="Отчество" v-model="user.otch"></v-text-field>

          <v-text-field
            :rules="rules.emailRules"
            label="*Контактный Email"
            v-model="user.emailContact"
            prepend-icon="email"
            type="email"
            required
          ></v-text-field>

          <v-text-field
            placeholder="(xxx)xxx xx xx"
            prepend-icon="phone"
            v-mask="rules.phonemask"
            prefix="+7"
            :rules="rules.phoneRules"
            label="*№ телефона"
            v-model="user.phone"
          ></v-text-field>
          <v-text-field
            label="Комментарий к телефону"
            v-model="user.phone_note"
          ></v-text-field>

          <v-text-field
            label="Должность"
            v-model="user.position"
          ></v-text-field>

          <v-text-field label="Адрес" v-model="user.address"></v-text-field>

          <v-text-field
            label="Краткая информация"
            v-model="user.bio"
          ></v-text-field>

          <v-text-field
            label="Дата рождения"
            type="date"
            v-model="user.date"
          ></v-text-field>

          <v-select
            v-model="user.role"
            :items="roles"
            item-text="name"
            item-value="role"
            label="Роль"
            required
            :rules="rules.emptyRules"
          ></v-select>
          <v-row v-if="user.role === 'bank' || user.role === 'bankAdmin'">
            <v-col cols="12">
              <v-select
                v-model="user.bank"
                :items="product.banks"
                label="Банк"
                item-text="name"
                item-value="id"
              />
              <Website
                :sortList="getBankWebsite(product.banks, user.bank)"
                v-model="user.website"
                v-if="user.bank"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="user.role === 'agregator' || user.role === 'agregatorAdmin'"
          >
            <v-col cols="12">
              <Website v-model="user.website" :multiple="false" />
              <v-select
                v-model="user.bank"
                :items="product2.banks"
                label="Банк"
                item-text="name"
                item-value="id"
                multiple
                v-if="user.website"
              />
            </v-col>
          </v-row>
          <v-row v-if="user.role === 'bank' || user.role === 'agregator'">
            <v-col cols="6">
              <v-checkbox
                label="Роль только для чтения"
                v-model="user.onlyRead"
                class="check"
              />
            </v-col>
            <v-col cols="6">
              <v-checkbox
                label="Активирован"
                v-model="user.active"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" :disabled="progress">Отмена (закрыть)</v-btn>
        <v-btn @click="save" :disabled="progress" :loading="progress"
          >Записать</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Globalrules from "../../components/api/rules.js";
import Website from "@/views/calcsettings/components/website.vue";
import { roleObj } from "@/plugins/roles";

export default {
  components: { Website },
  data() {
    return {
      roleObj,
      show1: false,
      show2: false,
      user: {
        email: "",
        famil: "",
        name: "",
        otch: "",
        position: "",
        phone: "",
        phone_note: "",
        address: "",
        bio: "",
        date: "",
        emailContact: "",
        role: "",
        bank: [],
        website: [],
        onlyRead: false,
        active: false,
      },
      progress: false,
      password1: "",
      password2: "",
      loading: false,
      rules: Globalrules,
      error: "",
      valid: true,
      organisationID: null,
      product2: null,
    };
  },
  async mounted() {
    this.setTitle(`Добавить пользователя: ${this.user.name}`);
    const { data } = await this.$store.dispatch("GetCalcSettingsCS");
    // console.log('data',data);
    this.product2 = data;
    this.getBanksInfo();
    this.organisationID = this.$store.getters.GetCurrentOrganisationIDUM;
    if (!this.organisationID) {
      Swal.fire({
        icon: "error",
        title: "Организация пользователя не определена",
        text: "Этот путь нельзя вызвать напрямую.",
      });
      this.$store.commit("SET_CURRENT_ORGANISATION_UM", {});
      this.$router.push({ name: "usermanagement" });
    }
  },
  watch: {
    "user.role"(newVal, oldVal) {
      // console.log("user.role", newVal);
      if (!oldVal) {
        return;
      }
      if (!newVal) {
        return;
      }
      if (newVal !== oldVal) {
        if (newVal === "bank" || newVal === "bankAdmin") {
          this.user.bank = "";
          this.user.website = [];
          this.user.onlyRead = false;
        }
        if (newVal === "agregator" || newVal === "agregatorAdmin") {
          this.user.website = "";
          this.user.bank = [];
          this.user.onlyRead = false;
        }
      }
    },
  },
  methods: {
    async getBanksInfo() {
      await this.$store.dispatch("getProductCS", 1);
      const profile = JSON.parse(localStorage.getItem("profile"), true);
      // console.log("profile", profile);
      if (profile.role === "bank" || profile.role === "bankAdmin") {
        // console.log("bank");
        this.user.bank = JSON.parse(profile.bank)[0];
        this.user.website = JSON.parse(profile.website);
        return;
      }
      if (profile.role === "agregator" || profile.role === "agregatorAdmin") {
        // console.log("agregator");
        this.user.website = JSON.parse(profile.website)[0];
        this.user.bank = JSON.parse(profile.bank);
        return;
      }

      this.user.website = JSON.parse(profile.website);
      this.user.bank = JSON.parse(profile.bank);
    },
    close() {
      this.$router.push("/usersorganisationtable?redirect=adminpanelfinexpert");
    },

    save() {
      this.progress = true;
      if (!this.$refs.form.validate()) {
        Swal.fire({
          icon: "error",
          title: "Не все поля заполнены правильно",
          text: "Проверьте правильность заполнения обязательных полей",
        });
        this.progress = false;
        return;
      }

      var data = {
        email: this.user.email,
        famil: this.user.famil,
        name: this.user.name,
        otch: this.user.otch,
        position: this.user.position,
        phone: this.user.phone,
        phone_note: this.user.phone_note,
        address: this.user.address,
        bio: this.user.bio,
        date: this.user.date,
        emailContact: this.user.emailContact,
        role: this.user.role,
        firm_id: this.organisationID,
        bank:
          typeof this.user.bank === "object"
            ? JSON.stringify(this.user.bank)
            : `[${this.user.bank}]`,
        website:
          typeof this.user.website === "object"
            ? JSON.stringify(this.user.website)
            : `[${this.user.website.replace("[", "").replace("]", "")}]`,
        onlyRead: this.user.onlyRead,
        active: this.user.active,
      };

      this.$store
        .dispatch("addUserOfFirm", data)
        .then(() => {
          if (this.$store.getters.getErrorApi == "FIRMNOTFOUND") {
            Swal.fire({
              icon: "error",
              title: "Что то пошло не так",
              text: "Ваша фирма удалена из базы данных. Обратитесь к администратору.",
            });
            this.progress = false;
            return;
          }
          if (this.$store.getters.getErrorApi == "EMAILNOTUNIQUE") {
            Swal.fire({
              icon: "error",
              title: "Email не уникальный",
              text:
                "Пользователь с email " +
                this.user.email +
                " уже зарегистрирован в системе.",
            });
            this.progress = false;
            return;
          }
          if (this.$store.getters.getErrorApi == "OK") {
            Swal.fire({
              icon: "success",
              title: "Сохранено!",
              text: "Пользователь успешно добавлен.",
            });
            this.progress = false;
            this.$router.push(
              "/usersorganisationtable?redirect=adminpanelfinexpert"
            );
          }
        })
        .catch((error) => {
          this.progress = false;
          Swal.fire({
            icon: "error",
            title: "Ошибка!",
            text: "Пользователь не добавлен.",
          });
        });
    },

    gen_password(len) {
      var password = "";
      var symbols =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!№;%:?*()_+=";
      for (var i = 0; i < len; i++) {
        password += symbols.charAt(Math.floor(Math.random() * symbols.length));
      }
      return password;
    },

    generatePwd() {
      var pwd = this.gen_password(8);
      this.password1 = this.password2 = pwd;
    },

    saveAndEmailAnonymous() {
      this.loading = true;
      var data = {
        user_id: this.user.user_id,
      };
      this.$store
        .dispatch("changePasswordUserOfFirmAnon", data)
        .then(() => {
          if (this.$store.getters.getErrorApi == "OK") {
            Swal.fire({
              icon: "success",
              title: "Успешно!",
              text: "Пароль изменен на новый",
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.error = error;
          this.loading = false;
        });
    },
    saveAndEmail() {
      if (this.password1 != this.password2) {
        Swal.fire({
          icon: "error",
          title: "Ошибка!",
          text: "Пароли должны совпадать.",
        });
        return;
      }
      if (this.password1.length < 6) {
        Swal.fire({
          icon: "error",
          title: "Ошибка!",
          text: "Длина пароля не должна быть меньше 6 символов.",
        });
        return;
      }
      this.loading = true;
      var data = {
        password: this.password1,
        user_id: this.user.user_id,
      };
      this.$store
        .dispatch("changePasswordUserOfFirm", data)
        .then(() => {
          if (this.$store.getters.getErrorApi == "PASSWORDERROR") {
            Swal.fire({
              icon: "error",
              title: "Ошибка!",
              text: "Неверный формат пароля",
            });
          } else if (this.$store.getters.getErrorApi == "OK") {
            Swal.fire({
              icon: "success",
              title: "Успешно!",
              text: "Пароль изменен на новый",
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.error = error;
          this.loading = false;
        });
    },
  },
  computed: {
    roles() {
      return this.getRoles();
    },
    product() {
      return this.$store.getters.getProductData;
    },
  },
};
</script>

<style lang="scss"></style>
